// Import model
import { UpdatePushNotificationRegistrationResponse } from '../models/UpdatePushNotificationRegistrationResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdatePushNotificationRegistrationResponse - handles JSON serialization and deserialization with type validation
 */
export class UpdatePushNotificationRegistrationResponseSerializer {
  /**
   * Deserializes a JSON string into a UpdatePushNotificationRegistrationResponse instance
   */
  static deserialize(json: string): UpdatePushNotificationRegistrationResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdatePushNotificationRegistrationResponse instance
   */
  static fromObject(obj: any): UpdatePushNotificationRegistrationResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdatePushNotificationRegistrationResponse');
    }


    const instance: UpdatePushNotificationRegistrationResponse = {
      registrationId: obj['registrationId'] as string,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdatePushNotificationRegistrationResponse instances
   */
  static deserializeArray(json: string): UpdatePushNotificationRegistrationResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdatePushNotificationRegistrationResponse instance to a JSON string
   */
  static serialize(instance: UpdatePushNotificationRegistrationResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdatePushNotificationRegistrationResponse instance to a plain object
   */
  static toObject(instance: UpdatePushNotificationRegistrationResponse): any {
    return {
      'registrationId': instance.registrationId,
    };
  }

  /**
   * Serializes an array of UpdatePushNotificationRegistrationResponse instances to a JSON string
   */
  static serializeArray(instances: UpdatePushNotificationRegistrationResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
